import * as rd from '@devexperts/remote-data-ts'
import { createSelector } from '@reduxjs/toolkit'
import { MapElementWithSectorId } from '@/models/map'
import { cartSlice } from '@/store/cartSlice'
import { mapSelectors } from '@/store/mapSlice.ts'

type MapElements = Record<string, MapElementWithSectorId>
const mapElements = createSelector(
  [mapSelectors.mapRemoteData],
  (data): MapElements | null => {
    if (!rd.isSuccess(data)) return null

    if (!data.value.elements) return null
    return data.value.elements.reduce(
      (acc, item) => {
        acc[item.id] = item
        return acc
      },
      {} as Record<string, MapElementWithSectorId>
    )
  }
)

const cartMapSpotsSelector = createSelector(
  [mapElements, cartSlice.selectors.items],
  (mapElements, items) => {
    const cartItemsIds = Object.keys(items)
    if (cartItemsIds.length === 0 || !mapElements) return []
    return cartItemsIds
      .map((id) => {
        const mapElement = mapElements[id]
        return mapElement ? mapElement : null
      })
      .filter(Boolean) as MapElementWithSectorId[]
  }
)

export const cartReservationsWithSpotSelector = createSelector(
  [cartSlice.selectors.cartReservations, cartMapSpotsSelector],
  (cartReservations, mapSpots) => {
    if (cartReservations.length === 0 || mapSpots.length === 0) return []

    return mapSpots.map((spot) => {
      const reservation = cartReservations?.find(
        (reservation) =>
          reservation.spotName === spot.name &&
          reservation.spotType === spot.subType
      )

      if (!reservation) return null

      return {
        reservation,
        spot,
      }
    })
  }
)
